import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { App } from './App';
import { queryClient } from './lib/queryClient';
import './index.css';

const root = document.getElementById('root');
if (!root) {
  throw new Error('Élément #root introuvable dans index.html');
}

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// --- Service worker (PWA) ---
// Uniquement en production : en développement il mettrait en cache des fichiers
// que Vite recharge à chaud, ce qui donnerait des comportements incohérents.
// Un échec d'enregistrement n'est pas bloquant — l'app fonctionne sans.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err: unknown) => {
      console.warn('Service worker non enregistré :', err);
    });
  });
}
